module.exports = __webpack_public_path__ + "images/icons/cards/visa-25de8b88.svg";